import React from 'react'
import ReactMarkdown from 'react-markdown'

export default function MDText(props) {
  return <ReactMarkdown {...props} />
}



// WEBPACK FOOTER //
// ./src/components/shared/MDText.js